export const AS_SON_AS_POSIBLE = 'AS_SON_AS_POSIBLE'
export const SCHEDULED = 'SCHEDULED'
export const TIME_MODES = [AS_SON_AS_POSIBLE, SCHEDULED]


export const TAKE_AWAY = 'TAKE_AWAY'
export const DELIVERY = 'DELIVERY'
export const SALON = 'SALON'

export const DELIVERY_MODES = [TAKE_AWAY, DELIVERY, SALON]
